export const BUILDER_DESRIPTION_LIMIT = 280;
